import * as types from "./MenuTypes";

const INITIAL_STATE = {
  hotelKey: null,
  selectedCategory: null,
  category: [],
  categoryLoaded: false,
  searchPhrase: "",
  combo: [],
  comboCategories: [],
  comboModified: [],
  sortedCategoryMenu: [],
  loyaltyMenu: [],
  sortedComboMenu: [],
  showCategoryHomeMenu: false,
  menuVersion: null,
  isScrolled: false,
  activeCategory: null,
  prodSuggest: null,
  cartSuggest: null,
  // New state for v2 API
  categoriesV2: [],
  categoriesV2Loading: false,
  categoriesV2Error: null,
  selectedCategoryV2: null,
  productsV2: {},
  productsV2Loading: {},
  productsV2Error: {},
  productsV2Pagination: {},
};

// Replace with you own reducer
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_MENU_REQUEST:
      return {
        ...state,
        hotelKey: action.payload,
        // selectedCategory: null,
        searchPhrase: "",
        category: [],
        categoryLoaded: false,
      };
    case types.GET_LOYALTY_MENU_RECEIVE:
      return {
        ...state,
        loyaltyMenu: action.payload,
      };
    case types.GET_MENU_RECEIVE:
      return {
        ...state,
        category: action.payload,
        sortedCategoryMenu: action.payload,
        categoryLoaded: true,
      };
    case types.GET_COMBO_MENU_RECEIVE:
      const sortedList = action.payload.sort((a, b) => {
        return a?.category_position - b?.category_position;
      });
      const comboCategories = [...new Set(sortedList)];
      let comboModified = [];
      comboCategories.forEach((cc) => {
        comboModified = {
          ...comboModified,
          [cc.category_name]: action.payload.filter(
            (c) => c?.category_name === cc.category_name
          ),
        };
      });
      return {
        ...state,
        comboCategories,
        combo: action.payload,
        categoryLoaded: true,
        comboModified,
        sortedComboMenu: comboModified,
      };
    case types.SET_PROD_SUGGEST:
      return {
        ...state,
        prodSuggest: action.payload,
      };
    case types.SET_CART_SUGGEST:
      return {
        ...state,
        cartSuggest: action.payload,
      };
    case types.GET_MENU_CATEGORY_LIST_RECEIVE:
      return {
        ...state,
        selectedCategory:
          state.selectedCategory === action.payload ? null : action.payload,
      };
    case types.GET_MENU_ON_SEARCH:
      return {
        ...state,
        searchPhrase: action.payload,
      };
    case types.IS_HOME_SCROLLED:
      return {
        ...state,
        isScrolled: action.payload,
      };
    case types.CLEAR_MENU:
      return {
        ...state,
        selectedCategory: null,
        category: [],
        categoryLoaded: false,
        searchPhrase: "",
      };
    case types.FILTER_MENU_CATEGORY:
      return {
        ...state,
        sortedCategoryMenu: action.payload,
      };
    case types.FILTER_MENU_COMBO:
      return {
        ...state,
        sortedComboMenu: action.payload,
      };
    case types.SET_MENU_VERSION:
      return {
        ...state,
        menuVersion: action.payload,
      };
    case types.SET_ACTIVE_CATEGORY:
      return {
        ...state,
        activeCategory: action.payload,
      };
    case types.REMOVE_ACTIVE_CATEGORY:
      return {
        ...state,
        activeCategory: null,
      };
    case types.SHOW_CATEGORY_HOME_MENU:
      return {
        ...state,
        showCategoryHomeMenu: action.payload,
      };
    
    // New reducer cases for v2 API
    case types.GET_CATEGORIES_V2_REQUEST:
      return {
        ...state,
        categoriesV2Loading: true,
        categoriesV2Error: null,
      };
    
    case types.GET_CATEGORIES_V2_SUCCESS:
      return {
        ...state,
        categoriesV2: action.payload,
        categoriesV2Loading: false,
        categoriesV2Error: null,
      };
    
    case types.GET_CATEGORIES_V2_FAILURE:
      return {
        ...state,
        categoriesV2Loading: false,
        categoriesV2Error: action.payload,
      };
    
    case types.GET_PRODUCTS_V2_REQUEST:
      return {
        ...state,
        productsV2Loading: {
          ...state.productsV2Loading,
          [action.payload.categoryId]: true,
        },
        productsV2Error: {
          ...state.productsV2Error,
          [action.payload.categoryId]: null,
        },
      };
    
    case types.GET_PRODUCTS_V2_SUCCESS: {
      const { products, categoryId, hasMore, page, pagination } = action.payload;
      return {
        ...state,
        productsV2: {
          ...state.productsV2,
          [categoryId]: page > 0
            ? [...(state.productsV2[categoryId] || []), ...products]
            : products,
        },
        productsV2Loading: {
          ...state.productsV2Loading,
          [categoryId]: false,
        },
        productsV2Error: {
          ...state.productsV2Error,
          [categoryId]: null,
        },
        productsV2Pagination: {
          ...state.productsV2Pagination,
          [categoryId]: pagination || { hasMore },
        },
      };
    }
    
    case types.GET_PRODUCTS_V2_FAILURE:
      return {
        ...state,
        productsV2Loading: {
          ...state.productsV2Loading,
          [action.payload.categoryId]: false,
        },
        productsV2Error: {
          ...state.productsV2Error,
          [action.payload.categoryId]: action.payload.error,
        },
      };
    
    case types.SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategoryV2: action.payload,
      };
    
    case types.CLEAR_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategoryV2: null,
      };
    
    default:
      return state;
  }
};

export default reducer;
